// extracted by mini-css-extract-plugin
export default {"White":"#FFFFFF","BreakpointToMedium":"(max-width: 639px)","shadowOpacityLow":"rgba(0,0,0,0.05)","wrapper":"Gf450f7"};